<template>
    <div>
        <div>
            <h1 class="mb-1.5 mt-14">Enter one-time email code</h1>
            <p class="mb-4 text-sm text-ds-primary-500">
                Email verification is required. Check your <strong>email inbox</strong> and enter the one-time use code you
                received.
            </p>
        </div>
        <div>
            <code-input
                :error
                type="text"
                @code="captureCode"
                @keyup.enter="validateVerificationCode"
            />
            <div
                v-if="error && !verificationCodeResent"
                class="text-ds-red-500"
            >
                The code entered does not match the last code sent. Check the number and try again, or click resend code.
            </div>
            <div
                v-else-if="verificationCodeResent"
                class="text-ds-red-500"
            >
                Verification Code has been resent.
            </div>
            <span
                class="hover:text-underline cursor-pointer text-sm text-ds-primary-500"
                @click="resendCode"
            >
                Resend Code
            </span>
        </div>
        <div class="mt-24">
            <button
                class="text-uppercase block w-full bg-ds-primary-900 px-4 py-2 text-center font-medium text-white hover:bg-semantic-primary-hover focus:outline-none focus:ring-2 focus:ring-semantic-primary-hover focus:ring-offset-2"
                type="button"
                @click="validateVerificationCode"
            >
                Login
            </button>
        </div>
    </div>
</template>

<script setup lang="ts">
import { notifyError } from '@/bugsnag';
import type { AxiosError } from 'axios';
import { ref } from 'vue';
import { httpClient } from '../Plugins/HttpClient';
import CodeInput from './CodeInput.vue';

const emit = defineEmits<{ verificationCodeValid: [] }>();

const verificationCode = ref('');
const verificationCodeResent = ref(false);
const error = ref(false);

const validateVerificationCode = () => {
    verificationCodeResent.value = false;
    httpClient
        .post('/client/login/validateVerificationCode', {
            verification_code: verificationCode.value,
        })
        .then((response: unknown) => {
            if (response === 'verification code validated') {
                emit('verificationCodeValid');
            }
        })
        .catch(() => {
            error.value = true;
        });
};

const captureCode = (code: string) => {
    verificationCode.value = code;
};

const resendCode = () => {
    httpClient
        .post('/client/login/sendVerificationCode')
        .then((response: unknown) => {
            verificationCodeResent.value = response === 'emailed verification code';
        })
        .catch((error: AxiosError) => {
            if (error.response?.data === 'Missing values in session') {
                verificationCodeResent.value = false;
            } else {
                notifyError(error, 'EmailVerificationComponent:resendCode', {
                    response: error.response ?? {},
                });
            }
            console.error(error);
        });
};
</script>
